import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from 'reducers';
import apiMiddleware from 'middlewares/api-middleware';
import unauthorizedMiddleware from 'middlewares/unauthorized-handler';

// Creates a preconfigured store for this example.
export default function configureStore(defaultState) {
  const middlewares = [thunk, apiMiddleware, unauthorizedMiddleware];
  if (process.env.NODE_ENV === 'development') {
    /* eslint-disable global-require */
    // Only want to require it when in development mode.
    const logger = createLogger({
      level: 'info',
      collapsed: true,
      duration: true,
    });
    middlewares.push(logger);
  }

  /* eslint-disable no-underscore-dangle */
  const composeEnhancers = (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
  /* eslint-enable */

  return createStore(rootReducer, defaultState, composeEnhancers(
    applyMiddleware(...middlewares)
  ));
}
